/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component (cart line item: forwards delCart with the app controller)
 *   extends:   Component (@glimmer/component)
 *   template:  list-cart-product.hbs
 *   args:      @delCart, @applicationController
 *   uses:      -
 *   siblings:  -
 *   tests:     glimmer-actions-test.js
 *
 * Thin action wrapper: forwards category/item removal to the host's @delCart,
 * always passing along @applicationController.
 */
import Component from '@glimmer/component';

import { action } from '@ember/object';

export default class ListCartProductComponent extends Component {
  @action
  delCart(category, item) {
    this.args.delCart(category, item, this.args.applicationController);
  }
}
